import { render, staticRenderFns } from "./SpamUsersList.vue?vue&type=template&id=35387743&scoped=true&"
import script from "./SpamUsersList.vue?vue&type=script&lang=js&"
export * from "./SpamUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35387743",
  null
  
)

export default component.exports